import React, { Component } from "react";

export default class RequestError extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h4 className="text-center">Something went wrong. Please try again</h4>;
    }

    return this.props.children;
  }
}
